import appEvents from 'src/modules/10-app/events';
import { isSessionRebootstrapping } from 'src/modules/authentication/session/ensureGuestSession';
export default function handleInvalidToken(instance) {
    instance.interceptors.response.use(response => {
        return response;
    }, err => {
        if (err.response) {
            const { response } = err;
            if (+response.status === 401 && !isSessionRebootstrapping()) {
                appEvents.onLogout();
                return;
            }
        }
        return err;
    });
}
